import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the viewport to the top whenever the route pathname changes.
 *
 * - Reset `history.scrollRestoration` to "manual" once on mount so the
 *   browser doesn't try to preserve the previous page's scroll position
 *   on SPA navigations (root cause of business pages opening at the footer).
 * - Skips the reset when there's a URL hash (e.g. /page#section) so anchor
 *   links keep working.
 * - Honors location.state.preserveScroll === true if a caller wants to
 *   keep the current scroll (e.g. back-to-search restoration in the future).
 */
export default function ScrollToTop() {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    if (hash) return;                       // let the browser jump to the anchor
    if (state?.preserveScroll) return;      // explicit opt-out
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, state]);

  return null;
}
